import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Button, Paper } from '@mui/material';
import Select from 'react-select';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { FocusError } from 'focus-formik-error';
import { useDispatch, useSelector } from 'react-redux';
import { BeatLoader } from 'react-spinners';
// import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { toast } from 'react-toastify';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { getCustomerRegData } from '../../../Redux/action/Admin/CustomerAction';

import { adminMainUrl } from "../../../Config.jsx";

const BankDetails = ({ customer_id }) => {
  let [disable, setDisable] = useState(false);
  let [showLoader, setShowLoader] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    console.log(customer_id)
    if (customer_id) {
      dispatch(getCustomerRegData(customer_id))
    }
  }, []);

  let {
    loadingCustomerRegDataApi,
    CustomerRegDataError,
    CustomerRegData,
  } = useSelector(state => state?.CustomerReducer);


  let initialValues = {

    bankName: "",
    bankAddress: "",
    beneficiaryName: "",
    bankAccountNum: "",
    ifscCode: "",
    customer_id: "",

  }

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({


    }),
    onSubmit: (values, { resetForm }) => {

    }
  });

  useEffect(() => {
    if (CustomerRegData) {
      formik.setValues({
        bankName: CustomerRegData?.bankName ?? "",
        bankAddress: CustomerRegData.bankAddress ?? "",
        beneficiaryName: CustomerRegData.beneficiaryName ?? "",
        bankAccountNum: CustomerRegData.bankAccountNum ?? "",
        ifscCode: CustomerRegData.ifscCode ?? "",


      })
    }
  }, [CustomerRegData])

  return (
    <>
      {/* <Toaster /> */}
      {
        // <div className="page-wrapper">
        //   <div className="content">
        <div id="section2" className="section2 customer_main_detail_form">
          <form onSubmit={formik.handleSubmit} className='p-4'>
            <div className='form-heading-bg'>
              <span>Bank Details</span>

            </div>
            <FocusError formik={formik} />
            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    for="basicpill-firstname-input"
                    className="form-label"
                  >
                    Bank Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='bankName'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.bankName}
                    maxLength={200}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.bankName && formik.errors.bankName ? (
                      <div className='text-danger small'>{formik.errors.bankName}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    for="basicpill-firstname-input"
                    className="form-label"
                  >
                    Bank Address
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='bankAddress'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.bankAddress}
                    maxLength={200}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.bankAddress && formik.errors.bankAddress ? (
                      <div className='text-danger small'>{formik.errors.bankAddress}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    for="basicpill-firstname-input"
                    className="form-label"
                  >
                    Beneficiary Name
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='beneficiaryName'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.beneficiaryName}
                    maxLength={30}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.beneficiaryName && formik.errors.beneficiaryName ? (
                      <div className='text-danger small'>{formik.errors.beneficiaryName}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    for="basicpill-firstname-input"
                    className="form-label"
                  >
                    Account No.
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='bankAccountNum'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.bankAccountNum}
                    maxLength={20}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.bankAccountNum && formik.errors.bankAccountNum ? (
                      <div className='text-danger small'>{formik.errors.bankAccountNum}</div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label
                    for="basicpill-firstname-input"
                    className="form-label"
                  >
                    IFSC Code
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="basicpill-firstname-input"
                    placeholder="Enter here"
                    name='ifscCode'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.ifscCode}
                    maxLength={20}
                  />
                  <div className="help-block with-errors">
                    {formik.touched.ifscCode && formik.errors.ifscCode ? (
                      <div className='text-danger small'>{formik.errors.ifscCode}</div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>


          </form>
        </div >
        //   </div>
        // </div>
      }
    </>

  )
}

export default BankDetails